import React, { useState } from 'react';
import { ModalPortal } from 'AppSrc/core/components/portals/modal-portal';
import 'AppSrc/core/style/components/help/feedback.scss';

// Svg Component For Feedback
const FeedbackAvatar = () => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    height="42"
    width="42"
    color="#fff"
  >
    <path d="M22 1h-7a2.44 2.44 0 00-2.41 2l-.92 5.05a2.44 2.44 0 00.53 2 2.47 2.47 0 001.88.88H17l-.25.66a3.26 3.26 0 003 4.41 1 1 0 00.92-.59l2.24-5.06A1 1 0 0023 10V2a1 1 0 00-1-1zm-1 8.73l-1.83 4.13a1.33 1.33 0 01-.45-.4 1.23 1.23 0 01-.14-1.16l.38-1a1.68 1.68 0 00-.2-1.58A1.7 1.7 0 0017.35 9h-3.29a.46.46 0 01-.35-.16.5.5 0 01-.09-.37l.92-5A.44.44 0 0115 3h6zM9.94 13.05H7.05l.25-.66A3.26 3.26 0 004.25 8a1 1 0 00-.92.59l-2.24 5.06a1 1 0 00-.09.4v8a1 1 0 001 1h7a2.44 2.44 0 002.41-2l.92-5a2.44 2.44 0 00-.53-2 2.47 2.47 0 00-1.86-1zm-.48 7.58A.44.44 0 019 21H3v-6.73l1.83-4.13a1.33 1.33 0 01.45.4 1.23 1.23 0 01.14 1.16l-.38 1a1.68 1.68 0 00.2 1.58 1.7 1.7 0 001.41.74h3.29a.46.46 0 01.35.16.5.5 0 01.09.37z" />
  </svg>
);


const FeedBack = React.memo(() => {
  const [openFeedbackModel, setopenFeedbackModel] = useState(false);
  const [rating, setRating] = useState(0);
  const [feedback, setFeedback] = useState('');

  const onClickCloseFeedbackModel = () => {
    setopenFeedbackModel(!openFeedbackModel);
    setRating(0);
    setFeedback('');
  };

  const onClickOpenFeedbackModel = () => {
    setopenFeedbackModel(!openFeedbackModel);
  };

  const handleFeedbackSubmit = (e) => {
    e.preventDefault();
    setRating(0);
    setFeedback('');
  };
  const handleStarClick = (value) => {
    setRating(value);
  };

  const readyToSubmit = rating || feedback;

  const onHandleCommunication = () => {
    const email = 'aceportaldevops@vodafone.com';
    const subject = 'Feedback on ACE Portal';
    const body = `Hi ACE Team,%0D%0D

Feedback Rating: ${rating}%0D%0D
Summarise your feedback: ${feedback}%0D%0DThanks,`;

    window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
  };

  return (
    <>
      <div className="outer-individual-wrap">
        <div className="feedback-model-button ">
          <button
            type="button"
            onClick={onClickOpenFeedbackModel}
          >
            <FeedbackAvatar />
            <p>Give Feedback</p>
          </button>
        </div>
        {openFeedbackModel
          && (
            <ModalPortal>
              <div className="feedback-model">
                <div className="feedback-model-shadow" />
                <div className="feedback-model-inner">
                  <main className="feedback-main">
                    <form onSubmit={handleFeedbackSubmit} className="feedback-form">
                      <h1>Please Rate Us</h1>
                      <h2>How was your experience using our application? Your rating matters!</h2>

                      <div className="star-rating-question">
                        {[1, 2, 3, 4, 5].map((value) => (
                          <label key={value} htmlFor={`rating-${value}`}>
                            <input
                              type="radio"
                              name="rating"
                              id={`rating-${value}`}
                              value={value}
                              checked={rating === value}
                              onChange={() => handleStarClick(value)}
                              style={{ display: 'none' }}
                            />
                            <span className={`star ${rating >= value ? 'active' : ''}`}>&#9733;</span>
                          </label>
                        ))}
                      </div>

                      <div className="feedback-textarea-group">
                        <label htmlFor="feedback-comment-rating">
                          <span>Summarise your feedback :</span>
                          <textarea
                            id="feedback-comment-rating"
                            placeholder="Additional feedback ..."
                            name="feedback"
                            value={feedback}
                            onChange={(e) => setFeedback(e.target.value)}
                          />
                        </label>
                        <p className="feedback-note">By pressing Submit, your feedback will be used to improve the ACE Portal.</p>
                      </div>
                      <div className="form-modal-options form-options-spacemaker" />
                      <div className="form-modal-options">
                        <div className="side-left">
                          <button
                            type="button"
                            className="cancel-button"
                            onClick={onClickCloseFeedbackModel}
                          >
                            Close
                          </button>
                        </div>
                        <div className="side-right">
                          <button
                            type="button"
                            onClick={onHandleCommunication}
                            className={`save-button save-button-${readyToSubmit ? 'ready' : 'not-ready'}`}
                            disabled={!readyToSubmit}
                          >
                            Submit
                          </button>
                        </div>
                      </div>
                    </form>
                  </main>
                </div>
              </div>
            </ModalPortal>
          )}
      </div>
    </>
  );
});


export { FeedBack };
